import { cn } from '@/lib/utils';
import {
  formatConfidencePercent,
  getConfidenceTier,
} from '@/utils/enrichment-adapter';

interface EnrichmentConfidenceBadgeProps {
  /** Confidence score between 0.0 and 1.0 */
  confidence: number;
  /** Size variant */
  size?: 'sm' | 'md';
  /** Additional class names */
  className?: string;
}

const tierStyles = {
  high: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  medium: 'bg-amber-100 text-amber-700 border-amber-200',
  low: 'bg-red-100 text-red-700 border-red-200',
} as const;

const sizeStyles = {
  sm: 'text-[10px] px-1.5 py-0.5',
  md: 'text-xs px-2 py-0.5',
} as const;

/**
 * Displays a confidence score as a colored badge.
 * - Green (emerald) for >=70%
 * - Yellow (amber) for 40-69%
 * - Red for <40%
 */
export const EnrichmentConfidenceBadge = ({
  confidence,
  size = 'md',
  className,
}: EnrichmentConfidenceBadgeProps) => {
  const tier = getConfidenceTier(confidence);
  const percentText = formatConfidencePercent(confidence);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border font-medium whitespace-nowrap',
        tierStyles[tier],
        sizeStyles[size],
        className,
      )}
    >
      {percentText} Confident
    </span>
  );
};
